import { Table, Button, Badge } from 'react-bootstrap';
import PageFade from '../../components/animation/PageFade';

const reviews = [
  { id: 'r1', product: 'Wireless Headphones', customer: 'Jane', rating: 5, status: 'approved' },
  { id: 'r2', product: '4K Monitor', customer: 'John', rating: 3, status: 'pending' },
];

export default function Reviews() {
  return (
    <PageFade>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Reviews</h3>
        <div className="d-flex gap-2">
          <Button size="sm" variant="outline-success">
            Approve
          </Button>
          <Button size="sm" variant="outline-danger">
            Reject
          </Button>
        </div>
      </div>
      <Table hover responsive>
        <thead>
          <tr>
            <th>Product</th>
            <th>Customer</th>
            <th>Rating</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {reviews.map((review) => (
            <tr key={review.id} style={{ backgroundColor: "#fff" }}>
              <td>{review.product}</td>
              <td>{review.customer}</td>
              <td>{'★'.repeat(review.rating)}</td>
              <td>
                <Badge bg={review.status === 'approved' ? 'success' : 'warning'}>{review.status}</Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PageFade>
  );
}

